/** Created by azhou on 2019/1/16.*/
<template>
  <div class="register-input">
    <span class="input-label">{{labelText}}</span>
    <input :type="type"
           :value="value"
           @input="$emit('input',$event.target.value)"
           :placeholder="placeholder"/>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'BgGreyInput',
    props: {
      value: {},
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String
      },
      labelText: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapState(['userLoginMessage']),
      ...mapGetters(['userInfo'])
    }
  }
</script>
<style lang="scss" scoped>
  .register-input {
    background: #eee;
    border: 1px solid #ccc;
    margin: 20px auto;
    border-radius: 5px;
    padding: 8px 10px;
    width: 350px;
    display: flex;
    align-items: center;
    .input-label {
      width: 70px;
      margin-right: 10px;
      display: inline-block;
      text-align-last: justify;
      font-size: 14px;
    }
    input {
      -webkit-appearance: none;
      -moz-appearance: none;
      border: none;
      background: #eee;
      height: 25px;
      &:focus {
        outline: none;
      }
    }
  }
</style>
